import { Routes } from '@angular/router';

import { routes as authRoutes } from '@routes/auth.routes';
import { routes as privateRoutes } from '@routes/private.routes';
import { routes as publicRoutes } from '@routes/public.routes';

export const routes: Routes = [
  ...publicRoutes,
  ...authRoutes,
  ...privateRoutes,
  {
    path: 'forbidden',
    loadComponent: () => import('@components/pages/auth/forbidden/forbidden.component')
      .then((module) => module.ForbiddenComponent),
    title: 'Access denied',
  },
  {
    path: '**',
    loadComponent: () => import('@components/pages/public/not-found/not-found.component')
      .then((module) => module.NotFoundComponent),
    title: 'Page not found',
  },
];
